import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '@env';

/**
 * Attaches the same JWT as Apollo GraphQL (`userSecret`) to HttpClient calls
 * that target this app’s REST API (e.g. /api/chatvion/* proxy).
 * Without this, [Authorize] endpoints return 401 while GraphQL still works.
 */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('userSecret');
    const apiBase = (environment.API_URL || '').replace(/\/$/, '');

    let outgoing = req;
    if (token) {
      const url = req.url;
      const isOurRestApi =
        (apiBase.length > 0 && url.startsWith(apiBase)) ||
        (url.startsWith('/api/') && !/^https?:\/\//i.test(url));

      if (isOurRestApi) {
        outgoing = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    }

    return next.handle(outgoing).pipe(finalize(() => {}));
  }
}
